import { Tab, Tabs, Typography } from '@mui/material';
import Avatar from 'further-ui/components/Avatar';
import { Column, Row } from 'further-ui/components/Layout';
import { SyntheticEvent } from 'react';
import { TabType } from './types';
import CloseButton from 'components/new/FullPageDrawer/CloseButton';

type Props = {
  investorName: string;
  currentTab: TabType;
  onTabChange: (tabKey: TabType) => void;
  onClose: () => void;
  tabs: Array<{
    label: string;
    key: TabType;
  }>;
  banner?: React.ReactNode;
};

const Header: React.FC<Props> = ({
  investorName,
  currentTab,
  tabs,
  onTabChange,
  onClose,
  banner,
}) => {
  const handleTabChange = (_: SyntheticEvent, newTabKey: TabType) => {
    onTabChange(newTabKey);
  };

  return (
    <Column spacing="sm" fullWidth>
      <Row centered spacing="xs" justify="space-between">
        <Row centered spacing="xs">
          <Avatar color="random" text={investorName} size="lg" />
          <Typography variant="h4">{investorName}</Typography>
        </Row>
        <CloseButton onClose={onClose} />
      </Row>
      {banner}
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons={false}
      >
        {tabs.map((tab) => (
          <Tab key={tab.key} label={tab.label} value={tab.key} />
        ))}
      </Tabs>
    </Column>
  );
};

export default Header;
